import ScalarIconSlidersHorizontal_vue_vue_type_script_setup_true_lang_default from "./ScalarIconSlidersHorizontal.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconSlidersHorizontal.vue
var ScalarIconSlidersHorizontal_default = ScalarIconSlidersHorizontal_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconSlidersHorizontal_default as default };

//# sourceMappingURL=ScalarIconSlidersHorizontal.js.map